
export default {
  props: {
    team: {
      type: Object,
      required: true,
    },
    light: {
      type: Boolean,
      default: false,
    },
    ignoreSize: {
      type: Boolean, // Ignore the size difference between Aberdeen logo and others
      default: false,
    },
    ignoreTbc: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    logo () {
      return this.getClubLogo(this.team, this.light) ?? null;
    },
    fallbackLogo () {
      return this.siteSettings?.default_logo_image?.sizes.large;
    },
  },
};
